const UPDATE_CLIENT_PROFILE_SCHEMA = schema.object({
  country_id: schema.string().nullish(),
  form_avatar_files: schema
    .custom<FileList>()
    .nullish()
    .refine(
      (files) => {
        return [...(files ?? [])].every((file) => {
          return formatFileSize(file.size) <= 5;
        });
      },
      localeStringReplacement(localeValidation().fileSize, {
        size: `5 ${localeValidation().megabytes}`,
      }),
    )
    .refine((files) => {
      return [...(files ?? [])].every((file) => {
        return ["image/jpeg", "image/jpg", "image/png"].includes(file.type);
      });
    }, localeValidation().fileType),
  language_id: schema.string().nullish(),
  name: schema.string().nullish(),
  phone: schema
    .string()
    .nullish()
    .refine(
      (value) => {
        if (!value) return true;

        const digits = value.replaceAll(/\D/g, "");

        if (digits.length <= 4) return true;

        const phoneRegex = /^\+\d{7,15}$/;

        return phoneRegex.test(value.replaceAll(/\s+/g, ""));
      },
      {
        message: localeValidation().invalidPhone,
      },
    ),
  surname: schema.string().nullish(),
  timezone: schema.string().nullish(),
  priority_project_id: schema.string().nullish(),
});

type UpdateClientProfileFields = FormFields<UpdateClientProfileSchemaInfer>;

type UpdateClientProfileForm = UpdateClientProfileMutationVariables & {
  form_avatar_files?: FileList;
};

type UpdateClientProfileSchemaInfer = SchemaInfer<typeof UPDATE_CLIENT_PROFILE_SCHEMA>;

export { UPDATE_CLIENT_PROFILE_SCHEMA };
export type { UpdateClientProfileFields, UpdateClientProfileForm };
